export enum EvaluationFormItemType {
    Unknown = 0,
    Text = 1,
    SingleDropDownSelection = 2,
    RadioButton = 3,
    MultipleDropDownSelection = 4,
    DueDiligenceSingleOptionSelection = 5,
    DueDiligenceFeatureItem = 6,
    List = 7,
    RecordAnswer = 8,
 }
